import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import Row from 'react-bootstrap/Row'; import { MenuLateral } from '../MenuLateral/MenuLateral'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf } from '@fortawesome/free-solid-svg-icons'; // Importa el icono faBars
import Nav from 'react-bootstrap/Nav';
import { fichaOne500, folletoOne500 } from '../../Archivos/one500';
import './One500.css';

export function One500() {

    const [fotoSeleccionada, setFotoSeleccionada] = useState(null);
    const [subtituloModal, setSubtituloModal] = useState("");

    const modalFoto = (foto, subtitulo) => {
        setFotoSeleccionada(foto);
        setSubtituloModal(subtitulo)
    };

    const logoPdf = <FontAwesomeIcon icon={faFilePdf} size="xl" style={{ color: "#006c87", }} />

    const abrirPdf = (archivo) => {
        window.open(archivo, '_blank');
    };

    const archivosPDF = {
        ficha: fichaOne500,
        folleto: folletoOne500,
        
    };

    const clicEnlacePdf = (tipoArchivo) => {
        abrirPdf(archivosPDF[tipoArchivo]);
    };

    return (
        <>
            <div className="mainContainer">
                <MenuLateral />

                <div className='contenedorProducto'>
                    <div className='row'>
                        <div className='col-xl-3 col-lg-3 col-md-12 col-sm-12'>
                            <div className='imagenesOne500'>

                                <Row>
                                    <div className='contenedorFoto' >
                                        <img className="imagenProductoOne500"
                                            src={require("../Img/one500.webp")}
                                            
                                            onClick={() => modalFoto(require("../Img/one500.webp"), 'ONE 500')}
                                            alt='ONE 500' />
                                    </div>
                                </Row>
                                <Row>
                                    <div className='contenedorFoto' >
                                        <img className="imagenProductoOne500"
                                            src={require("../Img/one500Interior.webp")}
                                            
                                            onClick={() => modalFoto(require("../Img/one500Interior.webp"), 'ONE 500 Interior')}
                                            alt='ONE 500 Interior' />
                                    </div>
                                </Row>

                            </div>
                        </div>
                        <div className='col-xl-6 col-lg-6 col-md-12 col-sm-12'>
                            <div className='descripcionOne500'>
                                <h2 className='nombreProductoOne500'>One 500</h2>
                                <h5 className='tituloProductoOne500'>Detectores 4-20mA por tecnología infrarroja para la detección de gases explosivos y
                                    CO2 compatibles con cualquier sistema con entradas estándar 4-20mA y con las centrales DURGAS y EUROSONDELCO mediante
                                    Interface.
                                </h5>
                                <p className='textoProductoOne500'>
                                    DIREX ha sido especialmente diseñado para:
                                </p>
                                <ul className='listadoOne500'>
                                    <li>Instalaciones con presencia de gases inhibidores o venenosos de detectores catalíticos –pellistores-.
                                        Estos gases no afectan a DIREX.</li>
                                    <li>En atmósferas donde no haya presencia de oxígeno. DIREX, al contrario que los pellistores, no necesita oxigeno para
                                        su funcionamiento.</li>
                                    <li>Instalaciones en las que las operaciones de mantenimiento se deban reducir al mínimo. DIREX solo requiere una
                                        revisión cada 3 años.</li>
                                </ul>
                                <p className='textoProductoOne500'>
                                    En la detección  por infrarrojos, al contrario que otras tecnologías, la presencia del gas a detectar no reduce la vida útil
                                    del sensor. DIREX no se ve afectado por este fenómeno.
                                    <br />
                                    Gases disponibles: Metano, Gas Natural, Propano y CO2.

                                    Disponibles en versión plástica IP65 (DIREX)  y ATEX antideflagrante (DIREX-X) con certificado ATEX LOM08ATEX2059 X.
                                    <br />
                                    Rango de detección de 0 a 100% L.I.E. (explosivos) y de 0 a 2% vol (CO2).
                                    <br />
                                    Indicaciones ópticas de avería de lazo y de sensor.
                                    <br />
                                    Módulo de relé de alarma programable opcional: 1 nivel de alarma programable, desconexión instantánea/retardada, programación
                                    retardo de desconexión y estado inicial del relé en reposo.
                                    <br />
                                    Calibrados en fábrica con gas patrón: no necesitan ser recalibrados en la instalación.
                                    <br />
                                    También disponible en formato RS485C.
                                </p>
                            </div>

                        </div>
                        <div className='col-lg-3 col-md-12'>

                            <div className='contenedorNavOne500'>
                                <Nav as="ul" className="flex-column">
                                    <Nav.Item className='linksArchivosOne500' as="li" onClick={() => clicEnlacePdf('ficha')}>
                                        {logoPdf}
                                        Ficha One 500
                                    </Nav.Item>
                                    <Nav.Item className='linksArchivosOne500' as="li" onClick={() => clicEnlacePdf('folleto')}>
                                        {logoPdf}
                                        Folleto One 500
                                    </Nav.Item>
                                    
                                </Nav>
                            </div>
                        </div>
                    </div>

                </div>

            </div >

            <Modal className='imgModalContainer' show={fotoSeleccionada !== null} onHide={() => setFotoSeleccionada(null)}>
                <Modal.Header closeButton>
                    {subtituloModal && <Modal.Title>{subtituloModal}</Modal.Title>}
                </Modal.Header>
                <Modal.Body>
                    {fotoSeleccionada && (<img src={fotoSeleccionada} alt="Foto One 5300" className="imgModal" />)}
                </Modal.Body>
            </Modal>

        </>
    );

}

